import { createFileRoute } from "@tanstack/react-router";
import LpGo from "@/pages/LpGo";
import { goHead } from "@/lib/goSeo";

export const Route = createFileRoute("/en/")({
  head: () => goHead("en"),
  component: () => <LpGo lang="en" />,
});
